import {docRoute} from '../page/doc/DocRoute'

export default [
  {path: '/doc/article/list', component: () => import('../page/doc/article-list')},
  {path: '/doc/article/:id', component: () => import('../page/doc/article')},
  /**
   * 医生评价
   * @query.docId
   */
  {path: '/doc/comment', component: () => import('../page/doc/comment')},

  {path: '/doc/index', component: () => import('../page/doc/index')},

  /**
   * 扫码获得免费咨询次数一次
   */
  {path: '/doc/scan', component: () => import('@/page/doc/scan')},
  ...docRoute
]



// WEBPACK FOOTER //
// ./src/router/doc.js